"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["color"],
    _excluded2 = ["color", "size"];

var _default = function _default(Comp) {
  var _this = this;

  var colorLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var sizeConf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var defaultTrans = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "none";
  var defaultComp = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "span";
  var _colorLimit$limit = colorLimit.limit,
      limit = _colorLimit$limit === void 0 ? [] : _colorLimit$limit,
      defaultColor = colorLimit.defaultColor;
  var WrappedComp = null;

  if (!sizeConf) {
    WrappedComp = function WrappedComp(_ref) {
      (0, _newArrowCheck2["default"])(this, _this);
      var color = _ref.color,
          others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

      if (limit.indexOf(color) < 0) {
        color = defaultColor;
      }

      return /*#__PURE__*/_react["default"].createElement(Comp, (0, _extends2["default"])({
        color: color
      }, others));
    }.bind(this);
  }

  var _sizeConf$sizeMap = sizeConf.sizeMap,
      sizeMap = _sizeConf$sizeMap === void 0 ? {} : _sizeConf$sizeMap,
      defaultSize = sizeConf.defaultSize,
      _sizeConf$enableSizeP = sizeConf.enableSizeProp,
      enableSizeProp = _sizeConf$enableSizeP === void 0 ? true : _sizeConf$enableSizeP;

  WrappedComp = function WrappedComp(_ref2) {
    (0, _newArrowCheck2["default"])(this, _this);
    var color = _ref2.color,
        size = _ref2.size,
        others = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);

    if (limit.indexOf(color) < 0) {
      color = defaultColor;
    }

    var mappedSize = sizeMap[enableSizeProp ? size : defaultSize] || {};
    return /*#__PURE__*/_react["default"].createElement(Comp, (0, _extends2["default"])({
      color: color,
      size: mappedSize.size,
      lineHeight: mappedSize.lineHeight
    }, others));
  }.bind(this);

  WrappedComp.propTypes = {
    /**
     * 设置文本颜色
     */
    color: _propTypes["default"].oneOf(limit),

    /**
     * 设置大小写
     */
    transform: _propTypes["default"].oneOf(["none", "lowercase", "uppercase", "capitalize", "initial"]),

    /**
     * 设置标签类型
     */
    component: _propTypes["default"].elementType
  };
  WrappedComp.defaultProps = {
    color: defaultColor,
    transform: defaultTrans,
    component: defaultComp
  }; // props是否添加size

  if (enableSizeProp) {
    WrappedComp.propTypes.size = _propTypes["default"].oneOf((0, _keys["default"])(sizeMap));
    WrappedComp.defaultProps.size = defaultSize;
  }

  return WrappedComp;
};

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/Typography/createTypo.js
// module id = 1269
// module chunks = 6 7 17 18